import React from 'react';
import { TrainingState, useTrainingStore } from '~/training/state';
import { SettingsPages, useSettingsStore } from '../Store';
import { LocalePage, LocalePageProps } from './LocalePage';

const selector = (s: TrainingState) => {
  const defaultLng = ['en'];

  if (s.textLocales.includes('es')) {
    defaultLng.push('es');
  }

  return {
    locale: s.textLocale,
    availableLocales: [
      ...defaultLng,
      ...s.textLocales.filter(i => i != 'en' && i != 'es')
    ],
    setLocale: s.setTextLocale
  };
};

const fullSelector = (s: TrainingState, callback?: (value: string) => void) => {
  const defaultLng = ['en'];

  const fullList = new Set([
    ...defaultLng,
    ...s.subtitleLocales,
    ...s.mediumLocales,
    ...s.textLocales
  ]);

  return {
    locale: s.textLocale,
    availableLocales: [...fullList],
    setLocale: (lang: string) => {
      if (callback) {
        callback(lang);
      }

      s.setLocale(lang);
    }
  };
};

export const TextLocalePage = (
  componentProps: Partial<LocalePageProps> & {
    selectedLocale?: string;
    setSelectedLocale?: (value: string) => void;
  }
) => {
  const props = useTrainingStore(
    componentProps.setSelectedLocale
      ? event => fullSelector(event, componentProps.setSelectedLocale)
      : selector
  );
  const { page } = useSettingsStore();
  if (page !== SettingsPages.TextLocale) return null;

  return <LocalePage {...props} {...componentProps} />;
};
